const banner = {
    tabSelectorTitle: 'Banner',
    settings: {
        inputs: {
            pauseOnHover: 'Zatrzymaj gdy najedziesz kursorem',
            autoPlay: 'Automatyczne przewijanie',
            enabled: 'Aktywny',
            animationType: 'Typ animacji',
            animationFallback: 'Wybierz typ',
            link: 'Odnośnik tła',
            dateTo: 'Aktywny do',
            dateFrom: 'Aktywny od',
            desktopImage: 'Ekran komputera',
            tabletImage: 'Ekran tabletu',
            mobileImage: 'Ekran telefonu',
            autoPlayDuration: 'Czas wyświetlania zdjęcia (sek)',
            alternativeText: 'Tekst alternatywny',
            buttonLink: 'Odnośnik przycisku',
            buttonContent: 'Treść przycisku',
            buttonColor: 'Kolor tła przycisku',
            saveAlert: 'Zapisz zmiany, aby móc dodać slajd',
            buttonFontColor: 'Kolor czcionki przycisku',
            file: {
                upload: 'PRZEŚLIJ ZDJĘCIE / VIDEO',
                remove: 'USUŃ WSZYSTKIE ZDJĘCIA / VIDEO',
                edit: 'PODMIEŃ ZDJĘCIE / VIDEO',
            },
            borderRadius: 'Zaokrąglenie obramowań'
        },
        button: {
            save: 'ZAPISZ ZMAINY'
        },
        animations: {
            fade: 'Przenikanie',
            standard: 'Slider'
        },
        actions: {
            save: 'ZAPISZ ZMIANY',
            cancel: 'ANULUJ',
            add: 'DODAJ SLAJD'
        },
        editModal: {
            header: 'Edytuj slajd'
        },
        location: 'Lokalizacja',
        columnNames: {
            order: 'Kolejność',
            desktopImage: 'Ekran komputera',
            tabletImage: 'Tablet',
            mobileImage: 'Telefon',
            activeInLanguage: 'Aktywne w językach',
            link: 'Link',
            dates: 'Okres aktywności',
            alternativeText: 'Tekst alternatywny',
            actions: 'Akcje',
            content: 'Treść'
        },
        emptyTable: 'Brak obrazów do wyświetlenia',
        emptyImage: 'Nie dodano zdjęcia dla tego typu urządzenia',
        tooltipTranslations: {
            edit: 'Edytuj',
            remove: 'Usuń'
        },
        deleteModalTranslations: {
            header: 'Usuń slajd',
            body: 'Czy chcesz usunąć wybrany slajd?',
            confirm: 'Usuń',
            cancel: 'Wróć'
        }
    },
};

export default banner;